export default {
  computed: {
    getAppMode() {
      return this.$store.state.common.appMode;
    },
  },
  methods: {
    routerLink($event, redirectTo) {
      // redirect to page
      if (redirectTo) {
        this.$router.push({ path: redirectTo.url, query: redirectTo.params });
      }
      else {
        const href = {};
        this.findHref($event.target, href, 2, 0);
        if (href.path) {
          // IS SPA LINK
          if (!href.path.includes('http') && !href.path.includes('tel:') && !href.path.includes('mailto:') && !href.path.includes('.pdf')) {
            $event.preventDefault();
            this.closeTab();
            window.scrollTo(0, 0);
            this.$router.push({ path: href.path });
          }
        }
      }
    },
    findHref(target, href, deep, ideep) {
      if (target && target.tagName && target.tagName.toLowerCase() === 'a') {
        href.path = target.getAttribute('href');
      } else if (target && target.tagName && ideep < deep) {
        this.findHref(target.parentNode, href, deep, ideep++);
      }
    },

    navigateToPath(toPath) {
      this.$router.push({
        path: toPath,
      });
      window.scrollTo(0, 0);
    },

    navigateToPage(id, type) {
      this.$router.push({
        path: this.$store.getters['applinks/getLink'](type, id).url,
      });
      window.scrollTo(0, 0);
    },
  },
};
